import { render, staticRenderFns } from "./ClassicCustomer.vue?vue&type=template&id=470a2838&scoped=true"
import script from "./ClassicCustomer.vue?vue&type=script&lang=js"
export * from "./ClassicCustomer.vue?vue&type=script&lang=js"
import style0 from "./ClassicCustomer.vue?vue&type=style&index=0&id=470a2838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470a2838",
  null
  
)

export default component.exports